var render = function render(){var _vm=this,_c=_vm._self._c;return _c('share-entity-dialog',{ref:"base",attrs:{"collection":"questionnaires","title":_vm.$t('questionnaires.share_questionnaire'),"shared-toast":_vm.$t('questionnaires.shared')}})
}
var staticRenderFns = []

export { render, staticRenderFns }